import { useRef, useEffect, useCallback } from 'react';

/**
 * Custom hook to temporarily skip pagination reset during data updates.
 * This prevents the table from jumping back to page 1 when data is updated.
 *
 * @returns [shouldSkip, skipOnce] - shouldSkip indicates if reset should be skipped,
 *                                   skipOnce is a function to trigger skipping for the next render
 */
export function useSkipper(): [boolean, () => void] {
  const shouldSkipRef = useRef(true);
  const shouldSkip = shouldSkipRef.current;

  const skipOnce = useCallback(() => {
    shouldSkipRef.current = false;
  }, []);

  useEffect(() => {
    shouldSkipRef.current = true;
  });

  return [shouldSkip, skipOnce];
}
